// extracted by mini-css-extract-plugin
module.exports = {"successWrap":"gl8GX","sucTitle":"JHDsV","shareBox":"m9XUy","shareTitle":"xfgfe","sucImgWrap":"TZnon","buttonWrap":"VcBG8","button":"p3sjp","sucContent":"As3C1"};